import React from 'react';

const LoadingSkeleton = ({ type = 'full' }) => {
  if (type === 'input') {
    return (
      <div className="bg-card border border-border rounded-lg p-6 shadow-elevation animate-pulse">
        <div className="flex items-center space-x-3 mb-4">
          <div className="w-10 h-10 bg-muted rounded-lg"></div>
          <div className="space-y-2">
            <div className="h-5 bg-muted rounded w-32"></div>
            <div className="h-3 bg-muted rounded w-48"></div>
          </div>
        </div>
        <div className="space-y-4">
          <div className="h-12 bg-muted rounded"></div>
          <div className="flex items-center space-x-3">
            <div className="h-10 bg-muted rounded w-32"></div>
            <div className="h-4 bg-muted rounded w-40"></div>
          </div>
        </div>
      </div>
    );
  }

  if (type === 'identification') {
    return (
      <div className="bg-card border border-border rounded-lg p-6 shadow-elevation animate-pulse">
        <div className="flex items-center space-x-3 mb-6">
          <div className="w-10 h-10 bg-muted rounded-lg"></div>
          <div className="space-y-2">
            <div className="h-5 bg-muted rounded w-48"></div>
            <div className="h-3 bg-muted rounded w-32"></div>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-1">
            <div className="aspect-video bg-muted rounded-lg"></div>
            <div className="mt-3 space-y-2">
              <div className="h-4 bg-muted rounded w-24 mx-auto"></div>
              <div className="h-3 bg-muted rounded w-16 mx-auto"></div>
            </div>
          </div>
          
          <div className="lg:col-span-2">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {Array.from({ length: 6 })?.map((_, index) => (
                <div key={index} className="flex items-center space-x-3 p-3 bg-muted rounded-lg">
                  <div className="w-8 h-8 bg-background rounded-md"></div>
                  <div className="flex-1 space-y-2">
                    <div className="h-3 bg-background rounded w-20"></div>
                    <div className="h-4 bg-background rounded w-32"></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (type === 'equipment') {
    return (
      <div className="bg-card border border-border rounded-lg p-6 shadow-elevation animate-pulse">
        <div className="flex items-center space-x-3 mb-6">
          <div className="w-10 h-10 bg-muted rounded-lg"></div>
          <div className="space-y-2">
            <div className="h-5 bg-muted rounded w-32"></div>
            <div className="h-3 bg-muted rounded w-48"></div>
          </div>
        </div>
        <div className="mb-6">
          <div className="h-10 bg-muted rounded"></div>
        </div>
        <div className="space-y-4">
          {Array.from({ length: 4 })?.map((_, index) => (
            <div key={index} className="border border-border rounded-lg overflow-hidden">
              <div className="flex items-center justify-between p-4 bg-muted">
                <div className="flex items-center space-x-3">
                  <div className="w-5 h-5 bg-background rounded"></div>
                  <div className="space-y-2">
                    <div className="h-4 bg-background rounded w-32"></div>
                    <div className="h-3 bg-background rounded w-24"></div>
                  </div>
                </div>
                <div className="w-5 h-5 bg-background rounded"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (type === 'commercial') {
    return (
      <div className="bg-card border border-border rounded-lg p-6 shadow-elevation animate-pulse">
        <div className="flex items-center space-x-3 mb-6">
          <div className="w-10 h-10 bg-muted rounded-lg"></div>
          <div className="space-y-2">
            <div className="h-5 bg-muted rounded w-40"></div>
            <div className="h-3 bg-muted rounded w-48"></div>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {Array.from({ length: 2 })?.map((_, index) => (
            <div key={index} className="p-4 bg-muted rounded-lg">
              <div className="flex items-center justify-between mb-2">
                <div className="flex items-center space-x-2">
                  <div className="w-4 h-4 bg-background rounded"></div>
                  <div className="h-4 bg-background rounded w-24"></div>
                </div>
                <div className="w-4 h-4 bg-background rounded"></div>
              </div>
              <div className="h-8 bg-background rounded mb-1"></div>
              <div className="h-3 bg-background rounded w-32"></div>
            </div>
          ))}
        </div>
        <div className="mt-4 p-4 bg-background border border-border rounded-lg">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-2">
              <div className="w-4 h-4 bg-muted rounded"></div>
              <div className="h-4 bg-muted rounded w-32"></div>
            </div>
            <div className="h-5 bg-muted rounded w-24"></div>
          </div>
        </div>
      </div>
    );
  }

  // Full loading skeleton
  return (
    <div className="space-y-6">
      <LoadingSkeleton type="input" />
      <LoadingSkeleton type="identification" />
      <LoadingSkeleton type="equipment" />
      <LoadingSkeleton type="commercial" />
    </div>
  );
};

export default LoadingSkeleton;